import { SpacesAttributesResponseApi } from "./get-spaces-attributes.types";
import { apiGateway } from "@/services/api-gateway";

export const GetSpacesAttributtesApi = async (spaceId: number) => {
  const { data } = await apiGateway.get<SpacesAttributesResponseApi>(
    `/api/v0/spaces/${spaceId}/attributes`,
  );

  return data?._embedded?.spaceattributes;
};
